import { ICoupon } from 'src/app/account/services/account.service';

export class CouponHelpers {
    public static getName(coupon: ICoupon, lang: string) : string {
        if (coupon.Translations.hasOwnProperty(lang))
            return coupon.Translations[lang].Name;

        return "";
    }

    public static getTerms(coupon: ICoupon, lang: string) : string {
        if (coupon.Translations.hasOwnProperty(lang))
            return coupon.Translations[lang].Terms;

        return "";
    }
}